import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check } from 'lucide-react';
const PRODUCT = 'Mega Pack Chi Kung';
const buyers = [{
  name: 'María G.',
  location: 'Ciudad de México'
}, {
  name: 'Julián L.',
  location: 'Bogotá'
}, {
  name: 'Carolina P.',
  location: 'Quito'
}, {
  name: 'Ricardo A.',
  location: 'Monterrey'
}, {
  name: 'Florencia B.',
  location: 'Santiago'
}, {
  name: 'Agustina S.',
  location: 'Lima'
}];
export const FloatingNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: 'María G.',
    location: 'Ciudad de México',
    time: 'hace 9 minutos'
  });
  useEffect(() => {
    const initialTimer = setTimeout(() => setIsVisible(true), 15000);
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
        setNotificationData({
          ...randomBuyer,
          time: `hace ${Math.floor(Math.random() * 59) + 1} minutos`
        });
        setIsVisible(true);
      }, 1000);
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-66" data-mp="1mwvj1egmdb4g">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      type: 'spring',
      stiffness: 340,
      damping: 28
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-xs" role="status" aria-live="polite" data-id="element-67" data-mp="1mvsu3c2uxir6">
          <div className="glass-panel p-4 rounded-sm flex items-start gap-3" data-id="element-68" data-mp="138cyja6k6lw3">
            <div className="border border-brand-gold/50 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-69" data-mp="136a4mf2ac8m3">
              <Check className="w-3.5 h-3.5 text-brand-goldDark" data-id="element-70" data-mp="z8uf6iudyivd" />
            </div>
            <div data-id="element-71" data-mp="u86oxzdze627">
              <p className="font-seal text-[9px] uppercase tracking-seal text-brand-muted mb-1.5" data-id="element-72" data-mp="u9rjvq47jr0l">
                Compra verificada · {notificationData.time}
              </p>
              <p className="text-sm text-brand-text" data-id="element-73" data-mp="on7jlb4zx5xa">
                <span className="font-semibold text-brand-purpleDark" data-id="element-74" data-mp="amen4kv4w0rj">
                  {notificationData.name}
                </span>{' '}
                de {notificationData.location} adquirió
              </p>
              <p className="text-sm text-brand-goldDark font-medium" data-id="element-75" data-mp="13aaklrsj1wpd">
                {PRODUCT}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};